import { useContext, useEffect, useRef, useState } from 'react'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { ScreenContainer, CustomContainer, AppSpan, AppText, FlexRow, GridContainer } from 'src/style'
import { supportOptions } from 'src/provider/config/constant'
import { FiChevronRight } from 'react-icons/fi'
import { ChatD3, Chats } from 'src/component'
import { useNavigate } from 'react-router-dom'

export const SupportD3: React.FC = () => {
    const navigate = useNavigate()
    const {notifier} = useContext(VisibilityContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const [view, setView] = useState('')
    const screenRef = useRef(false)

    useEffect(() => {
        screenRef.current = window.matchMedia('(max-width: 1150px)').matches
    }, [window])

    function handleSUpportView(type: string) {
        setView(type)

        if (type != 'realtime-chat') {
            const actionLink = document.createElement('a');
            document.body.appendChild(actionLink);

            if (type === 'contact-by-phone') actionLink.href = `tel:${institutionData.correspondencePhone}`
            else if (type === 'contact-by-email') actionLink.href = `mailto:${institutionData.correspondenceEmail}`
            else if (type === 'faq'){
                navigate('/dashboard/faq')
              }
            actionLink.click()
        }
    }
    const filteredSupportOptions = supportOptions.filter((item)=> !(item.view === "realtime-chat") && !institutionData?.hasLiveChat)

    
    return (
        <>
            <ScreenContainer padding='2.5' bottomPadding='0' topPadding='0'>
                <CustomContainer
                    customRadius='28px 28px 0px 0px' borderColor='#EAECF0'
                    minHeight='100' mnHUnit='%' bgColor='#FCFCFC' padding='2'
                    className='d2-screen-bg-img'
                >
                    <CustomContainer>
                        <AppSpan textSize='2.2' fontWeight='700'>Support</AppSpan>
                        <AppText>Manage your Account and Preferences here</AppText>
                    </CustomContainer>
                    <FlexRow
                        topMargin='2' justify-content='space-between'
                        alignItems='flex-start' gap='2'
                        className='d3-module-row-container'
                    >
                        <CustomContainer 
                            bgColor='#ffffff' radius='0.8'
                            leftPadding='1.5' rightPadding='1.5'
                            width='55' sizeUnit='%'
                            className='module-row-left-item'
                        >
                            {
                                filteredSupportOptions?.map((item: any, index: number) => {
                                    return (
                                        <GridContainer 
                                            minHeight='7.2' key={index} rightPadding='1'
                                            topPadding='0.5' bottomPadding='0.5'
                                            className='settings-item-container-d2'
                                            onClick={() => handleSUpportView(item.view)}
                                        >
                                            <FlexRow justifyContent='space-between' gap='1.5'>
                                                <FlexRow width='auto' sizeUnit='' gap='1.5' alignItems='flex-start'>
                                                    {item.icon.d3}
                                                    <CustomContainer width='auto' sizeUnit=''>
                                                        <AppSpan fontWeight='600' color='#101828' cursor='pointer'>{item.name}</AppSpan>
                                                        <AppText color='#667085' cursor='pointer'>{item.description}</AppText>
                                                    </CustomContainer>
                                                </FlexRow>
                                                <FiChevronRight 
                                                    style={{fontSize: '1.7rem', color: '#667085', flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                                />
                                            </FlexRow>
                                        </GridContainer>
                                    )
                                })
                            }
                        </CustomContainer>
                        { view === 'realtime-chat' &&
                            <ChatD3
                                close={() => setView('')} 
                            />
                        }
                    </FlexRow>
                    
                </CustomContainer>
            </ScreenContainer>
        </>
    )
}